module.exports = __webpack_public_path__ + "media/3.8ab0fcc2.mp3";